import { Avatar, AvatarGroup, Box, Stack } from '@mui/material'
import { User } from '__generated__/graphql'
import { LabelTypography } from 'recruiter/pages/Rosters/RosterProfile/styled'
import { getInitialsFromPreferredName, getPxAsRem } from 'shared/utils'

export interface SharedWithAvatarsProps {
    label: string
    users?: Pick<User, 'id' | 'preferredName' | 'profileImageKey'>[]
}

const SharedWithAvatars: React.FC<SharedWithAvatarsProps> = ({
    label,
    users,
}) => {
    return (
        <Stack
            direction={'column'}
            alignItems={'flex-start'}
            width={getPxAsRem(165, 165)}
        >
            <LabelTypography variant="overline" sx={{ whiteSpace: 'nowrap' }}>
                {label.toUpperCase()}
            </LabelTypography>
            <Box
                title={users
                    ?.map((user) => user.preferredName || '')
                    .join(', ')}
            >
                {users?.length ? (
                    <AvatarGroup
                        max={3}
                        sx={{
                            '& .MuiAvatarGroup-avatar': {
                                width: getPxAsRem(24),
                                height: getPxAsRem(24),
                                padding: '0.2rem',
                                fontSize: '0.7rem',
                            },
                            width: 'max-content',
                        }}
                    >
                        {users.map((user) => (
                            <Avatar
                                key={user.id}
                                src={user?.profileImageKey || ''}
                            >
                                {user &&
                                    getInitialsFromPreferredName(
                                        user.preferredName || ''
                                    )}
                            </Avatar>
                        ))}
                    </AvatarGroup>
                ) : (
                    '-'
                )}
            </Box>
        </Stack>
    )
}

export default SharedWithAvatars
